import React from 'react'
import CampaignManagerContainer from '../features/campaignManager/containers/CampaignManagerContainer'

const CampaignManagerView = () => {
  return <CampaignManagerContainer />
}

export default CampaignManagerView